import { render, staticRenderFns } from "./ResponsibilitiesListTable.vue?vue&type=template&id=fa237292&"
import script from "./ResponsibilitiesListTable.vue?vue&type=script&lang=js&"
export * from "./ResponsibilitiesListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports